<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <ModalEstudiante
        :typeForm="typeForm"
        :estudiante="estudiante"
        :activarModal="activarModal"
        :cambioForm="cambioForm"
        @listarEstudiantes="getEstudiantes"
      ></ModalEstudiante>

      <div class="row justify-content-center">
        <div class="col-lg-12">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-12"
            body-classes="px-lg-12 py-lg-12"
            class="border-0"
          >
            <h2 style="float:left">Listado de estudiantes</h2>

            <base-button
              type="primary"
              icon="ni ni-fat-add"
              size="lg"
              @click="crearForm"
              style="float:right;margin-botton:12px"
              >Crear estudiante</base-button
            >
            <table
              class="table table-bordered table-dark"
              style="margin-top: 60px;"
            >
              <thead>
                <tr>
                  <th scope="col">Nombre</th>
                  <th scope="col">Apellido</th>
                  <th scope="col">Cédula</th>                  
                  <th scope="col">Teléfono</th>
                  <th scope="col">Correo</th>
                  <th scope="col">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(estudiante, index) in estudiantes" :key="index">
                  <td v-text="estudiante.nombre"></td>
                  <td v-text="estudiante.apellido"></td>
                  <td v-text="estudiante.cedula"></td>                  
                  <td v-text="estudiante.telefono"></td>
                  <td v-text="estudiante.correo"></td>
                  <td style="display:inline-flex;border-top:none;border-right:none">
                    <base-button
                      type="warning"
                      icon="ni ni-settings"
                      size="sm"
                      @click="editarForm(estudiante)"
                    ></base-button>
                    <base-button
                      type="danger"
                      icon="ni ni-fat-delete"
                      size="sm"
                      @click="eliminarEstudiante(estudiante)"
                    ></base-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ModalEstudiante from "./components/ModalEstudiante";
export default {
  components: {
    ModalEstudiante,
  },
  data() {
    return {
      estudiantes: [],
      typeForm: "",
      estudiante: [],
      activarModal: false,
      cambioForm: "",
    };
  },
  created() {
    this.getEstudiantes();
  },
  methods: {
    async getEstudiantes() {
      this.activarModal = false;
      try {
        const { data } = await this.$api.get("students");
        this.estudiantes = data.data;
      } catch (error) {
        console.log("hubo un error al cargar los estudiantes");
      }
    },
    crearForm() {
      this.activarModal = true;
      this.cambioForm =
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15);
      this.typeForm = "Crear";
    },
    async editarForm(estudiante) {
      this.activarModal = true;
      this.cambioForm =
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15);
      this.typeForm = "Editar";
      this.estudiante = estudiante;
    },
    async eliminarEstudiante(estudiante){      
        var url = "students/" + estudiante.id;
        var method = "delete";
      
      try {
        await this.$api({
          url: url,
          method: method,
          
        });
      } catch (e) {
        if (e.response == "422") {
          console.log("422" + " " + e);
        } else {
          console.log(e);
        }
      }
      this.getEstudiantes();

    }
  },
  watch: {
    /*modalActive: function (val) {
      if (this.typeForm === 'Crear') {
        this.typeForm = 'Editar'        
      }else{
        this.typeForm = 'Crear';
      }
    }*/
  },
};
</script>
